import { ReactNode } from 'react';
import { asvTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={asvTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
